import React, { Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import { Outlet } from 'react-router';
import { ActivityIndicator } from '@kontentino/ui';

const BioPagesListPage = React.lazy(
  () => import('app/modules/bio/modules/pagesList'),
);
const BioPageCreatePage = React.lazy(
  () => import('app/modules/bio/modules/pageCreate'),
);
const BioPageEditorPage = React.lazy(
  () => import('app/modules/bio/modules/pageEditor'),
);
const BioPageAnalyticsPage = React.lazy(
  () => import('app/modules/bio/modules/pageAnalytics'),
);

export const bioRouter: RouteObject = {
  path: routeConfig.bio.path,
  element: (
    <Suspense
      fallback={
        <div className="tw-h-full tw-overflow-auto">
          <div className="tw-container tw-mx-auto tw-max-w-[1800px] tw-overflow-hidden">
            <ActivityIndicator />
          </div>
        </div>
      }
    >
      <div className="tw-h-full">
        <div className="tw-container tw-mx-auto tw-h-full tw-max-w-[1800px] tw-overflow-hidden">
          <Outlet />
        </div>
      </div>
    </Suspense>
  ),
  children: [
    {
      index: true,
      element: <BioPagesListPage />,
    },
    {
      path: routeConfig.bio.routes.create.path,
      element: <BioPageCreatePage />,
    },
    {
      path: routeConfig.bio.routes.editor.path,
      element: <BioPageEditorPage />,
    },
    {
      path: routeConfig.bio.routes.analytics.path,
      element: <BioPageAnalyticsPage />,
    },
  ],
};
